module.exports = __webpack_public_path__ + "img/empty.648180c0.gif";